module.exports = __webpack_public_path__ + "static/img/ninja-can-31.e92799c1.png";